import { AppState } from '../../../types/types';
import React, { ChangeEvent, useState } from 'react';
//import { CustomerDataContext } from "../../../components/context/CustomerDataProvider";
import { Box, Container, Grid, Button, TextField } from "@mui/material";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import { styled } from '@mui/material/styles';
import { IconButtonProps } from '@mui/material/IconButton';
import { AuthContext, CustomerContactStatusResponse } from "./../../../types/apimodel";

import IconDigitalePost from './../../../assets/images/check.svg';
import Exclamationmark from './../../../assets/images/exclamationmark.svg';
import { KEY_AUTH_CONTEXT, loadSessionData } from '../../../util/store';
import LinkedappBackend from '../../../services/LinkedappBackend';
import { log } from '../../../util/util';

//https://mui.com/material-ui/react-card/

interface Props {
    appState: AppState;
    customerContactStatusResponse?: CustomerContactStatusResponse | null;
    value?: string | '';

}

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));



const ContactChangeEmailCard: React.FC<Props> = (props) => {
    const [expanded, setExpanded] = useState(false);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const [email, setEmail] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(false);

    const [changeRequested, setChangeRequested] = useState(false);

    const handleNewEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setEmail(inputValue);

        // Validierung der E-Mail-Adresse
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailRegex.test(inputValue);
        setIsValidEmail(isValid);
        if (inputValue === props.customerContactStatusResponse?.email) {
            setIsValidEmail(false);
        }

    };


    function onBlur(event: any) {

    }

    function keyPress(event: any) {

    }

    const doNothing = (e) => {
        e.stopPropagation();
    }

    const setCustomercontactemailchange = (email: string) => {
        let linkid = loadSessionData('linkid');
        let authContext: AuthContext = loadSessionData(KEY_AUTH_CONTEXT);
        LinkedappBackend.setCustomercontactemailchange(linkid, authContext, email).then((data) => {
            log("Retrieved data: ", data);
        }).catch(error => {
            console.log('error in setCustomercontactemailchange: ' + JSON.stringify(error));
            //TODO unauthenticate if 401
        });
    }

    const changeContact = () => {
        setCustomercontactemailchange(email);
        setExpanded(false);
        setChangeRequested(true);
    }

    if (changeRequested && isValidEmail && props.customerContactStatusResponse?.email === email) {
        setChangeRequested(false);
    }

    const styles = {
        erneutSenden: {
            fontWeight: 'bold', // Fett darstellen
            cursor: 'pointer', // Cursor zur Hand ändern
        },
    };


    //const { customer } = useContext(CustomerDataContext);
    return <Container maxWidth="lg">
        <Grid item xs={12} sx={{}}>
            <Card sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
            }}>
                <CardHeader sx={{ alignSelf: "flex-end", marginBottom: "-90px", overflow: "100" }}

                    action={
                        <IconButton
                            onClick={handleExpandClick}
                            aria-expanded={expanded}
                            aria-label="mehr anzeigen"
                        >

                            <ExpandMore
                                expand={expanded}
                                onClick={handleExpandClick}
                                aria-expanded={expanded}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </IconButton>
                    }
                />

                {/* Hier können Sie zusätzlichen Inhalt einfügen, der sich erweitert/verringert */}
                <CardContent sx={{ alignSelf: "flex-start", width: '100%', }} onClick={handleExpandClick}>
                    <Box sx={{ display: "flex" }}>
                        <h4>Ihre E-Mail-Adresse</h4>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                        <Grid container spacing={2} justifyContent="space-between">
                            <Grid item xs={7} sm={7} md={5} lg={5}>
                                <Box>{props.customerContactStatusResponse?.email}</Box>
                            </Grid>
                            <Grid item xs={5} sm={5} md={7} lg={7}>

                                {!changeRequested && props.customerContactStatusResponse?.emailConfirment && <Box> <Box component="img" sx={{ width: { xs: '15px', sm: '15px', md: '15px', lg: '15px' }, marginLeft: '1rem', marginRight: '0.5rem' }} alt="Postfach" src={IconDigitalePost}></Box> verifiziert</Box>}
                                {changeRequested && isValidEmail && props.customerContactStatusResponse?.email !== email && <Box sx={{ display: 'flex', alignItems: 'flex-start' }}> <Box component="img" sx={{ width: { xs: '15px', sm: '15px', md: '15px', lg: '15px' }, marginLeft: '1rem', marginRight: '0.5rem', paddingTop: '5px' }} alt="Postfach" src={Exclamationmark}></Box> <Box >Bestätigen Sie Ihre E-Mail-Adresse durch klick auf den Link in der E-Mail, die wir Ihnen zugeschickt haben. <br /><span onClick={changeContact} style={styles.erneutSenden}>erneut senden</span></Box></Box>}

                            </Grid>
                        </Grid>
                    </Box>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <Grid container spacing={2} justifyContent="space-between" sx={{ marginTop: '10px' }}>
                            <Grid item xs={8} sm={8} md={6} lg={6}>
                                <Box sx={{ textAlign: 'left' }}>
                                    <TextField onChange={handleNewEmailChange}  onClick={doNothing} onBlur={onBlur} onKeyPress={keyPress} placeholder='Ihre neue Mailadresse' value={props.value}
                                        sx={{ width: '100%' }}

                                    />
                                    {!isValidEmail && props.customerContactStatusResponse?.email === email && <p style={{ color: 'red' }}>E-Mail bereits verifiziert.</p>}
                                    {!isValidEmail && props.customerContactStatusResponse?.email !== email && <p style={{ color: 'red' }}>Bitte geben Sie eine gültige E-Mail-Adresse ein.</p>}
                                </Box>
                            </Grid>
                            <Grid item xs={4} sm={4} md={6} lg={6}>
                                <Box sx={{ textAlign: 'right' }}>
                                    <Button sx={{ fontSize: "75%" }} onClick={changeContact} disabled={!isValidEmail}> Ändern</Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </Collapse>
                </CardContent>
            </Card>
        </Grid>
    </Container>


}

export default ContactChangeEmailCard;